<a xpo-regular-link (click)="openLink()" [id]="buttonId" [tabIndex]="tabIndex">
  <xpo-icon [iconName]="linkButtonInputs.iconName"></xpo-icon>{{ linkButtonInputs.buttonName }}
</a>
